

import { mapState } from 'vuex'
import { iconSvg, getTextFromEvent } from '~/utils/helpers'
import analytics from '~/mixins.js/analytics'

export default {
  mixins: [analytics],
  data: () => ({
    children: []
  }),
  props: {
    category: Object,
    currentCategory: {
      type: [Object, String],
      default: () => {}
    }
  },
  async mounted () {
    const { results } = await this.$serverBackend.get('/categories/', { parent: this.category.id})
    this.children = results
  },
  computed: {
    ...mapState(['categories']),
    icon () {
      return iconSvg(this.category.url)
    },
    sameCategory () {
      return this.category.id === this.currentCategory.id
    },
    sameBranch () {
      const firstCategory = this.category
      const latterCategory = this.currentCategory
      return firstCategory.id === latterCategory.parent || latterCategory.id === firstCategory.parent || firstCategory.id === latterCategory.id
    }
  },
  methods: {
    trackCategoryClick (event) {
      const name = getTextFromEvent(event)
      this.trackEvent('Navigation', name)
      return true
    }
  }
}

